
















































































































































import Vue from 'vue'
import Component from 'vue-class-component'

import Paypal from '../components/PayPal.vue'

@Component({
  components: {
    Paypal
  }
})
export default class Home extends Vue {
}
